export default "__VITE_ASSET__C3qoW5m9__"